import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth()

  // Still verifying stored token on first load — render nothing to avoid flash
  if (loading) return null

  if (!isAuthenticated) return <Navigate to="/login" replace />

  return children
}
